import { ParsedCustomFieldConfig } from '../types';

export const CUSTOM_FIELD_PREFIX = 'Feld';

export const createCustomFieldId = (customField: ParsedCustomFieldConfig) => {
  return `${CUSTOM_FIELD_PREFIX}${customField.fieldNumber}`;
};
